import { EnvironmentParams } from './environment.d';
//import { getRxStorageDexie } from 'rxdb/plugins/storage-dexie';
//import { getRxStorageMemory } from 'rxdb/plugins/storage-memory';
import { getRxStorageLoki } from 'rxdb/plugins/storage-lokijs';
import { wrappedValidateAjvStorage } from 'rxdb/plugins/validate-ajv';
import { addRxPlugin } from 'rxdb';
import { RxDBLeaderElectionPlugin } from 'rxdb/plugins/leader-election';
import { RxDBJsonDumpPlugin } from 'rxdb/plugins/json-dump';
import { RxDBDevModePlugin } from 'rxdb/plugins/dev-mode';
import { RxDBUpdatePlugin } from 'rxdb/plugins/update';
import { RxDBCleanupPlugin } from 'rxdb/plugins/cleanup';
import { RxDBMigrationPlugin } from 'rxdb/plugins/migration';
const LokiIncrementalIndexedDBAdapter = require('lokijs/src/incremental-indexeddb-adapter');

export const environment: EnvironmentParams = {
  name: 'prod',
  production: true,
  isCapacitor: false,
  isServerSideRendering: false,
  multiInstance: true,
  rxdbSyncUrl: 'http://' + window.location.hostname + ':0000/DATABASENAME',
  addRxDBPlugins() {
    addRxPlugin(RxDBDevModePlugin);
    addRxPlugin(RxDBLeaderElectionPlugin);
    addRxPlugin(RxDBJsonDumpPlugin);
    addRxPlugin(RxDBUpdatePlugin);
    addRxPlugin(RxDBCleanupPlugin);
    addRxPlugin(RxDBMigrationPlugin);
  },
  getRxStorage() {
    return wrappedValidateAjvStorage({
      //storage: getRxStorageDexie()
      //storage: getRxStorageMemory()
      storage: getRxStorageLoki({
        adapter: new LokiIncrementalIndexedDBAdapter(),
      }) 
    });
  },

  LS_CLU_APP_MODE_KEY: 'LS_CLU_APP_MODE_KEY',
  LS_MOBILE_AUTH_DOMAINE_KEY: 'LS_MOBILE_AUTH_DOMAINE_KEY'
};
